import {
  ValidatedSingleDateRangeValueInputProps,
  ValidatedSingleStringValueInputProps,
} from './types';
import {
  FIELD_TO_SINGLE_INPUT_MAP,
  FIELD_TYPE_TO_SINGLE_INPUT_MAP,
  CAST_TYPE_TO_SINGLE_INPUT_MAP,
} from './constants';
import { DateRangeSelect } from './date/DateRangeSelect';
import { isUsingInBetweenComparator } from '../../../utils';

export const SingleValueInput = (
  props: ValidatedSingleStringValueInputProps | ValidatedSingleDateRangeValueInputProps,
) => {
  const { field, fieldType, comparator, castType } = props;
  const InputForField = FIELD_TO_SINGLE_INPUT_MAP[field];
  const InputForFieldType = FIELD_TYPE_TO_SINGLE_INPUT_MAP[fieldType];
  const InputForCastType = CAST_TYPE_TO_SINGLE_INPUT_MAP[castType ?? ''];
  const Input = InputForCastType ?? InputForField ?? InputForFieldType;
  // if comparator is isBetween, use dateRangeInput instead

  if (isUsingInBetweenComparator(comparator)) {
    return <DateRangeSelect {...(props as ValidatedSingleDateRangeValueInputProps)} />;
  }
  return Input ? <Input {...(props as ValidatedSingleStringValueInputProps)} /> : <></>;
};
